import { render } from "./MainDisbursements.vue?vue&type=template&id=3cb549a8&scoped=true"
import script from "./MainDisbursements.vue?vue&type=script&lang=js"
export * from "./MainDisbursements.vue?vue&type=script&lang=js"

import "./MainDisbursements.vue?vue&type=style&index=0&id=3cb549a8&scoped=true&lang=css"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb549a8"]])

export default __exports__